import React from 'react'
// libs
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// constants
import { Forms, Modals } from 'constants/index'
// components
import { Modal } from 'components/UI'
import OptionEditForm from './Form'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { colors } from 'themes/index'
import { CloseIcon } from 'components/UI/Icons'
// utils
import { v4 as uuid } from 'uuid'

const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
}

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
`

const selector = formValueSelector(Forms.PROPERTY_EDIT_FORM)

const PickListOptionModal: React.FC = () => {
  const dispatch = useDispatch()

  const options = useSelector((state) => selector(state, 'options'))

  const {
    hideModal,
    modalData: { isOpen, option }
  } = useModalData({ modalType: Modals.PICKLIST_OPTION_MODAL })

  const handleSubmit = async (data) => {
    if (!option) {
      dispatch(
        change(Forms.PROPERTY_EDIT_FORM, 'options', [
          ...options,
          {
            id: uuid(),
            label: data.label,
            value: data.value,
            active: true
          }
        ])
      )
    } else {
      dispatch(
        change(
          Forms.PROPERTY_EDIT_FORM,
          'options',
          options.map((item) => {
            if (item.id === option.id) {
              return { id: option.id, active: data.active, label: data.label, value: data.value }
            }

            return item
          })
        )
      )
    }

    hideModal()
  }

  const initialValues = option
    ? {
        label: option.label,
        value: option.value,
        active: option.active
      }
    : {}

  return (
    <Modal
      width={'xs'}
      isOpen={isOpen}
      disableRestoreFocus
      disableBackdropClick
      disableEscapeKeyDown
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        <span>{option ? 'Edit' : 'Add'} Option</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <OptionEditForm isEdit={!!option} initialValues={initialValues} onSubmit={handleSubmit} hideModal={hideModal} />
    </Modal>
  )
}

export default PickListOptionModal
